var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.relatedDocument.length > 0 || _vm.relatedPeople.length > 0
    ? _c("div", [
        _c("div", { staticClass: "go-widget go-widget-sub" }, [
          _vm.relatedDocument.length > 0
            ? _c("div", { staticClass: "go-widget-header" }, [
                _c("div", { staticClass: "go-widget-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("report.relatedDocuments")) +
                      "\n\n        "
                  ),
                  _c("small", { staticClass: "go-count" }, [
                    _vm._v(_vm._s(_vm.relatedDocument.length)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-slide-pagination" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-slide-nav go-slide-nav-prev",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.prevPageDocument()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-20 go-icon-chevron-left",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-slide-page" }, [
                    _c("span", { staticClass: "go-slide-page-current" }, [
                      _vm._v(
                        _vm._s(_vm.articleRelatedDocumentPages.currentPage || 1)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-slide-page-total" }, [
                      _vm._v(_vm._s(_vm.totalPagesDocument() || 1)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-slide-nav go-slide-nav-next",
                      class:
                        _vm.articleRelatedDocumentPages.currentPage ===
                          _vm.totalPagesDocument() && "disabled",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.nextPageDocument()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-20 go-icon-chevron-right",
                      }),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "go-widget-body" }, [
            _c("div", { staticClass: "go-list-wrap" }, [
              _c(
                "ul",
                { staticClass: "go-card-sub-list go-card-related-document" },
                _vm._l(_vm.displayedItemsDocument(), function (item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "go-list-item",
                      on: {
                        click: function ($event) {
                          return _vm.handleRelatedDocument(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "go-card-sub" }, [
                        _c("div", { staticClass: "go-card-body" }, [
                          _c(
                            "a",
                            {
                              staticClass: "go-card-title",
                              attrs: { id: "go-panel-reference-detail-open" },
                            },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "go-card-info" }, [
                            _c("div", { staticClass: "go-elements" }, [
                              _c("span", { staticClass: "go-channel" }, [
                                _vm._v(
                                  _vm._s(
                                    Array.isArray(item.writer)
                                      ? item.writer[0]
                                      : "goover"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "go-datetime" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formattedDateDocument(item.published_at)
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("a", { staticClass: "go-card-img" }, [
                          _c("img", {
                            attrs: {
                              loading: "lazy",
                              src: item.image_uri_thumbnail,
                            },
                            on: {
                              error: function ($event) {
                                item.image_uri_thumbnail =
                                  "https://gooverai.com.s3-website-us-west-1.amazonaws.com/assets/images/common/file/file-pdf-fill.svg"
                              },
                            },
                          }),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.relatedPeople.length > 0
          ? _c("div", { staticClass: "go-widget go-widget-sub" }, [
              _c("div", { staticClass: "go-widget-header" }, [
                _c("div", { staticClass: "go-widget-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("report.relatedPeople")) +
                      "\n\n        "
                  ),
                  _c("small", { staticClass: "go-count" }, [
                    _vm._v(_vm._s(_vm.relatedPeople.length)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-slide-pagination" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-slide-nav go-slide-nav-prev",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.prevPagePeople()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-20 go-icon-chevron-left",
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-slide-page" }, [
                    _c("span", { staticClass: "go-slide-page-current" }, [
                      _vm._v(_vm._s(_vm.articleRelatedPeoplePages.currentPage)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "go-slide-page-total" }, [
                      _vm._v(_vm._s(_vm.totalPagesPeople() || 1)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-slide-nav go-slide-nav-next",
                      class:
                        _vm.articleRelatedPeoplePages.currentPage ===
                          _vm.totalPagesPeople() && "disabled",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.nextPagePeople.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "go-icon-20 go-icon-chevron-right",
                      }),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-widget-body" }, [
                _c("div", { staticClass: "go-list-wrap" }, [
                  _c(
                    "ul",
                    { staticClass: "go-card-sub-list go-card-related-people" },
                    _vm._l(_vm.displayedItemsPeople(), function (item, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "go-list-item" },
                        [
                          _c("div", { staticClass: "go-card-sub" }, [
                            _c(
                              "a",
                              {
                                staticClass: "go-card-img",
                                attrs: { href: "#" },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    loading: "lazy",
                                    src: item.imageSrc,
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "go-card-body" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "go-card-title",
                                  attrs: {
                                    id: "go-panel-reference-detail-open",
                                    href: _vm.social(
                                      item.social.Facebook,
                                      item.social.XTwitter,
                                      item.social.LinkedIn,
                                      item.social.Instagram
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(item.connectomeNodeLabel))]
                              ),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }